module.exports = __webpack_public_path__ + "img/bjx-modal@2x.df0b6dff.png";